export default "__VITE_ASSET__nHz0xObC__"